'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation as an emoji blowing confetti, in default color.
 */
export function ConfettiEmojiDefaultColorAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('../raw-json/emojis/confetti-emoji-default-color.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="ConfettiEmojiDefaultColorAnimation"
    />
  );
}
